import { inject, injectable } from 'inversify'
import { PlayerModule } from '@/app/api';
import { ExamResultService, ExamResultServiceSymbol } from './service'

@injectable()
export class ExamPlayerModule implements PlayerModule {
  readonly name = 'exam'
  
  constructor(
    @inject(ExamResultServiceSymbol)
    private examResultService: ExamResultService) {}

  start(): void {
    this.examResultService.start()
  }

  reset(): void {
  }

  async stop() {
    await this.examResultService.stop()
  }
}
